import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as React from "react";
import { Link } from "react-router-dom";

import { ArrowBack } from "@livechat/design-system-icons";
import { Button, Icon, IconSource, SpacingToken } from "@livechat/design-system-react-components";

import { IViewContainerTheme } from "interfaces/viewContainerTheme";

interface IProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to?: string;
  iconSource?: IconSource;
}

const BackButton = React.forwardRef<HTMLSpanElement, IProps>(({ to, iconSource, children, ...rest }, ref) => {
  BackButton.displayName = "BackButton";
  if (to) {
    return (
      <StyledLink to={to} {...rest}>
        <span ref={ref} css={{ display: "flex", alignItems: "center" }}>
          <Button kind="plain" size="compact" icon={<Icon source={iconSource ?? ArrowBack} />} />
          {children && <span className="name">{children}</span>}
        </span>
      </StyledLink>
    );
  }

  return (
    <StyledSpan ref={ref} hasChildren={!!children} {...rest}>
      <Button kind="plain" size="compact" icon={<Icon source={iconSource ?? ArrowBack} />} />
      {children && <span className="name">{children}</span>}
    </StyledSpan>
  );
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const commonCss = (theme: IViewContainerTheme) => css`
  font-size: 16px;
  cursor: pointer;
  height: 100%;
  color: ${theme.primaryColor};
  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 17px;

  &:hover {
    text-decoration: none;
  }

  .name {
    display: inline-block;
    font-size: 14px;
    margin-left: 9px;
  }
`;

interface IStyledSpan {
  hasChildren: boolean;
}

const StyledSpan = styled.span<IStyledSpan>`
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => commonCss(props.theme)
  }
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      !props.hasChildren &&
      `
margin-left: 0;
padding: 0 var(${SpacingToken.Spacing3});
`
  };
  display: flex;
  align-items: center;
`;

const StyledLink = styled(Link)`
  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => commonCss(props.theme)
  }
`;

export default BackButton;
